import range from 'lodash/range';
const inclusiveRange = (start, end)=>range(start, end + 1);
export function calculateRanges(currentPage, totalPages) {
    if (totalPages <= 5) {
        return {
            startingBlock: totalPages > 1 ? inclusiveRange(1, totalPages) : [],
            showStartDots: false,
            midBlock: [],
            showEndDots: false,
            endBlock: []
        };
    }
    const isNearStart = currentPage <= 3;
    const isNearEnd = currentPage >= totalPages - 2;
    const isMiddle = !isNearStart && !isNearEnd;
    const ranges = {
        startingBlock: isNearStart ? inclusiveRange(1, 3) : [
            1
        ],
        showStartDots: !isNearStart,
        midBlock: isMiddle ? inclusiveRange(currentPage - 1, currentPage + 1) : [],
        showEndDots: !isNearEnd,
        endBlock: isNearEnd ? inclusiveRange(totalPages - 2, totalPages) : [
            totalPages
        ]
    };
    return ranges;
}
